import { Subject, filter } from 'rxjs';
export function createTrunkService(isLogged, filterOperator = (isLogged) => (obs) => obs.pipe(filter(() => isLogged.value))) {
    const trunk = new Subject();
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    const next = (branches, handleError = () => { }) => {
        trunk.next([branches, handleError]);
    };
    return {
        asObservable: () => trunk.pipe(filterOperator(isLogged)),
        next,
        trigger: next
    };
}
//# sourceMappingURL=TrunkService.js.map